(function(){
  var FEED="https://marvelous-emu-462.convex.site/reviews/feed";
  function esc(s){var d=document.createElement("div");d.textContent=s==null?"":String(s);return d.innerHTML;}
  function stars(n){n=Math.round(Number(n)||0);var o="";for(var i=0;i<5;i++){o+=i<n?"\u2605":"\u2606";}return o;}
  function fmt(d){try{var p=String(d).split("-");if(p.length<3)return "";var m=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];return parseInt(p[2],10)+" "+m[parseInt(p[1],10)-1]+" "+p[0];}catch(e){return "";}}
  function trim(s,n){s=String(s);if(s.length<=n)return s;var c=s.slice(0,n);var i=c.lastIndexOf(" ");return (i>60?c.slice(0,i):c).replace(/[,.;:\s]+$/,"")+"\u2026";}
  function card(r){
    var m=(r.media||r.photos||[]).filter(function(p){return p&&(p.url||p.mediaUrl);});
    var after=m.filter(function(p){return (p.stage||"")==="after";})[0]||m[0];
    var img=after?'<img class="bphr-photo" loading="lazy" alt="Bison Products installation in '+esc(r.location||"the UK")+'" src="'+esc(after.url||after.mediaUrl)+'">':'';
    var who=[r.name||r.customerName||"Verified customer", r.location||""].filter(Boolean).join(", ");
    var dt=fmt(r.date);
    return '<figure class="bphr-card">'+img+
      '<figcaption><span class="bphr-stars">'+stars(r.rating)+'</span>'+
      (r.comment?'<p>&ldquo;'+esc(trim(r.comment,200))+'&rdquo;</p>':'')+
      '<span class="bphr-who">'+esc(who)+(dt?' &middot; '+dt:'')+'<span class="bphr-badge">Install signed off on site</span></span>'+
      '</figcaption></figure>';
  }
  try{
    fetch(FEED,{mode:"cors"}).then(function(r){return r.ok?r.json():null;}).then(function(d){
      var list=(d&&(d.reviews||d.items))||[];
      list=list.filter(function(r){return r&&r.comment;}).slice(0,3);
      if(!list.length) return;
      var g=document.getElementById("bphr-install-grid"); if(!g) return;
      g.innerHTML=list.map(card).join("");
      document.getElementById("bphr-installs").style.display="block";
    }).catch(function(){});
  }catch(e){}
})();
